import React from "react";
import { CSVLink } from "react-csv";

const tableColumn = [
  "Company Name",
  "Nature",
  "Company Email",
  "Supplier Code",
  "City",
  "Country",
  "Designated",
  "Currency",
  "Contact Person",
  "Contact",
  "Status",
];

function getRows(data) {
  return data && data.length > 0
    ? data.map((row) => {
        const contactPerson =
          row.fname && row.lname ? `${row.fname} ${row.lname}` : "--";

        return [
          row.company_name || "--",
          row.company_nature || "--",
          row.company_email || "--",
          row.supplier_code || "--",
          row.company_city || "--",
          row.company_country || "--",
          row.company_designation || "--",
          row.currency?.currency_name || "--",
          contactPerson,
          row.contact || "--",
          row.status || "--",
        ];
      })
    : [["No data"]];
}

const VendorCsv = ({ data, csvLinkRef }) => {
  let csvData = [];
  csvData.push(["SUPPLIER LIST"]);
  csvData.push([]);
  csvData.push(tableColumn);
  csvData = csvData.concat(getRows(data));

  return (
    <div>
      <CSVLink
        data={csvData}
        filename={"Supplier.csv"}
        className="text-decoration-none text-reset"
        target="_blank"
        ref={csvLinkRef}
      ></CSVLink>
    </div>
  );
};

export default VendorCsv;
